import { combineReducers } from 'redux'
import { accounts } from './Accounts'
import { users, searchUser, unitBaseUser, parentUserLimits } from './Users'
import { devices, searchRecently, parentUnitLimits } from './Devices'
import { groups } from './Groups'
import { logInUsers } from './logInUser'
import { ServerSetting } from './ServerSetting'
import { reports } from './Reports'
import { roles, searchRole } from './Roles'
import { privileges } from './Privileges'
import { templates } from './Templates'
import { themecolors } from './Theme'
// import { reducer as notificationSystem } from 'react-notification-system-redux'
import { trash } from './Trash'
import { coupon } from './Coupon'
import { sideBar } from './SideBar'
import { tab1,tab2,tab3,tab4,tab5,tab6,tab7,tab8,tab9,tab10,tab11,tab12,tab13,tab14,tab15, tab18, tab17, tab19} from './MaintenanceDashboard'
import { saleApi1, saleApi10, saleApi14, saleApi15, saleApi2, saleApi20, saleApi20a, saleApi3, saleApi4, saleApi5, saleApi6b, saleApi8, salePerformance, salePerformanceReducer, tabSale10, tabSale11, tabSale5, tabSale6, tabSale7, tabSale8, tabSale9 } from "./SaleDashboard";
import { ccApi1, ccApi10, ccApi11, ccApi12, ccApi14, ccApi15, ccApi16, ccApi17, ccApi2, ccApi20, ccApi3, ccApi4, ccApi5, ccApi6, ccApi6b, ccApi7, ccApi8, ccApi9 } from './CashDashboard'
import {Company} from './Company'
import { Cities } from './Cities'

export default combineReducers({
  accounts,
  users,
  searchUser,
  unitBaseUser,
  devices,
  parentUnitLimits,
  parentUserLimits,
  searchRecently,
  groups,
  logInUsers,
  ServerSetting,
  reports,
  themecolors,
  roles,
  searchRole,
  privileges,
  templates,
  Company,
  // notificationSystem,
  trash,
  coupon,
  sideBar,
  tab1,
  tab2,
  tab3,
  tab4,
  tab5,
  tab6,
  tab7,
  tab8,
  tab9,
  tab10,
  tab11,
  tab12,
  tab13,
  tab14,
  tab15,
  tab18,
  tab17,
  tab19,
  saleApi1,
  saleApi2,
  saleApi3,
  saleApi4,
  saleApi5,
  saleApi6b,
  saleApi8,
  saleApi10,
  saleApi14,
  saleApi15,
  saleApi20,
  salePerformance,
  saleApi20a,
  tabSale10,
  tabSale11,
  tabSale5,
  tabSale6,
  tabSale7,
  tabSale8,
  tabSale9,
  ccApi1,
  ccApi2,
  ccApi3,
  ccApi4,
  ccApi5,
  ccApi10,
  ccApi8,
  ccApi20,
  ccApi14,
  ccApi7,
  ccApi6,
  ccApi9,
  ccApi11,
  ccApi12,
  ccApi15,
  ccApi16,
  ccApi17,
  ccApi6b,
  Cities
})
